import calculator from './calculator';
import parseDependencies from './dependenciesParser';
export default {
  calculate: calculator.calculate,
  parseDependencies: parseDependencies
};